export { instance as eventsObserver } from 'plp/utils/eventsObserver/eventsObserver'
